import React, { useMemo } from "react";
import styled from "styled-components";
import iconActiveMenu from "../../../../../assets/images/Event-2025/Frame 25.png";
import iconActiveMenuActive from "../../../../../assets/images/Event-2025/Rectangle (2).png";
import {
  TAB_EVENT_FINISHED_NEW_YEAR,
  TAB_EVENT_NEW_YEAR,
} from "@config/constants/helper";
import { PATHS } from "@config/constants";
import { useHistory, useParams } from "react-router-dom";

export default function Menu({ statusEvent }) {
  const history = useHistory();
  const { id } = useParams();

  const handChangeTab = (id) => {
    history.push(`${PATHS.EVENT_2025}/${id}`);
  };

  const dataEventActive = useMemo(() => {
    if (!statusEvent?.is_finished) {
      return TAB_EVENT_NEW_YEAR;
    }

    return TAB_EVENT_FINISHED_NEW_YEAR;
  }, [statusEvent]);

  return (
    <Div>
      <div className="container-menu-event-2024">
        {dataEventActive.map((item) => {
          const isTabActive = item.id === id;
          return (
            <div
              key={item.id}
              className={`position-relative ${
                isTabActive ? "" : "tab-event-head"
              }`}
              onClick={() => handChangeTab(item.id)}
            >
              <img
                src={isTabActive ? iconActiveMenuActive : iconActiveMenu}
                alt=""
              />
              <div className="menu-event-new-year-2024">{item.title}</div>
            </div>
          );
        })}
      </div>
    </Div>
  );
}

const Div = styled.div`
  position: relative;
  width: 100%;
  padding: 0 20px;
  height: 74px;

  .container-menu-event-2024 {
    width: 100%;
    min-width: 750px;
  }

  .mobile-header {
    display: none;
  }

  .header-event_item {
    position: relative;
  }

  .tab-event-head {
    cursor: pointer;
  }

  .menu-event-new-year-2024 {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    text-align: center;
    color: #ffffff;
    font-size: 20px;
    font-weight: 600;
    line-height: 100%;
  }
  .container-menu-event-2024 {
    display: flex;
    gap: 20px;

    justify-content: center;
  }

  .icon-menu-head {
    width: 100%;
    position: absolute;
  }

  @media (min-width: 992px) {
    .tab-event-head:hover {
      scale: 1.05;
      transition: 0.3s ease-in-out;
    }
  }

  .custom-next-event {
    right: -12px;
  }

  .custom-prev-event {
    left: -12px;
  }
  .btn-custom-event {
    position: absolute;
    z-index: 2;
    top: 50%;
    transform: translateY(-50%);
    border-radius: 50%;
    border: 0px;
    background: #f97a1c;
    width: 24px;
    height: 24px;
    display: flex;
    gap: 15px;
    justify-content: center;
    align-items: center;

    svg {
      color: white;
    }
  }

  @media (max-width: 1400px) {
    padding: 0;
    height: 60px;
    .menu-event-new-year-2024 {
      font-size: 16px;
    }
    .container-menu-event-2024 {
      gap: 15px;
      height: 60px;
      .position-relative {
        width: 100%;
      }
      img {
        width: 100%;
        height: 60px;
      }
    }
  }

  @media (max-width: 1200px) {
    .container-menu-event-2024 {
      gap: 10px;
    }

    .menu-event-new-year-2024 {
      font-size: 14px;
    }
  }

  @media (max-width: 576px) {
    padding: 0;
    height: 50px;
    margin-top: 10px;

    .mobile-header {
      display: block;
    }
    .bg-header-event {
      height: 50px;
      width: 100%;
    }
    .swiper-wrapper {
      height: 100%;
    }

    .container-menu-event-2024 {
      /* display: none; */
    }
  }
`;
